import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

/** Shipping zones hierarchy — mirrors stacks-agents `src/app/api/shipping/`. */
@Injectable({ providedIn: 'root' })
export class ShippingApiService {
  constructor(private http: HttpClient) {}

  /** Builder JWT for the stacks-agents API */
  private agentsAuthHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` })
  }

  getShippingCountries(projectId: string): Promise<any[]> {
    return this.http
      .get<{ data?: any[] }>(`${environment.agentsUrl}v4/retrieval/shipping/countries`, {
        headers: this.agentsAuthHeaders(),
        params: { projectId },
      })
      .pipe(
        map(body => body?.data ?? []),
        catchError(() => of([])),
      )
      .toPromise() as Promise<any[]>
  }

  getShippingHierarchy(projectId: string): Promise<any[]> {
    return this.http
      .get<{ data?: any[] }>(`${environment.agentsUrl}v4/retrieval/shipping/hierarchy`, {
        headers: this.agentsAuthHeaders(),
        params: { projectId },
      })
      .pipe(
        map(body => body?.data ?? []),
        catchError(() => of([])),
      )
      .toPromise() as Promise<any[]>
  }

  /**
   * Replaces the project's entire shipping hierarchy (countries → states → cities → areas).
   * Unlike the reads, this rejects on failure — the caller needs to know the save didn't land.
   */
  async saveShipping(projectId: string, countries: any[]): Promise<void> {
    const res = await this.http
      .post(`${environment.agentsUrl}v4/creation/shipping`, { projectId, countries }, {
        headers: this.agentsAuthHeaders(),
      })
      .pipe(catchError(() => of(null)))
      .toPromise()
    if (res === null || res === undefined) throw new Error('saveShipping failed')
  }
}
